import Search from '@components/Search';
import { memo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import IndianMusicPageGridPosts from '../IndianMusicPageGridPosts';

interface ContentProps {
  scrollContainerRef?: React.RefObject<HTMLDivElement | null>;
}

export const IndianMusicPageContent = memo(
  ({ scrollContainerRef }: ContentProps) => {
    const { t } = useTranslation();
    const [selectedGenre, setSelectedGenre] = useState<string>('All');
    const [searchQuery, setSearchQuery] = useState<string>('');

    return (
      <div className="flex flex-col h-full pt-0 sm:pt-[10px]">
        <div className="flex-shrink-0">
          <h1 className="text-[32px] sm:text-[40px] px-[24px] font-normal leading-[140%] text-left text-[#fcfcfc] font-['DM_Serif_Text']">
            {t('indianMusic.title')}
          </h1>
          <div className="text-[14px] px-[24px] font-normal leading-[140%] text-left text-white/80 pb-4 font-[NapsterSans]">
            {t('indianMusic.subtitle')}
          </div>
          <Search
            selectedGenre={selectedGenre}
            onGenreChange={setSelectedGenre}
            searchQuery={searchQuery}
            onSearchChange={setSearchQuery}
            category="Indian music"
          />
        </div>

        <div
          ref={scrollContainerRef}
          className="flex-1 overflow-y-auto na-scroll-container">
          <div className="pb-[220px]">
            <IndianMusicPageGridPosts
              isActive
              scrollContainerRef={scrollContainerRef}
              genre={selectedGenre === 'All' ? undefined : selectedGenre}
              search={searchQuery.trim() || undefined}
            />
          </div>
        </div>
      </div>
    );
  },
);

IndianMusicPageContent.displayName = 'IndianMusicPageContent';
